<header class="topbar">
  <nav class="d-flex top-navbar navbar-expand-md navbar-light">
    <!-- ============================================================== -->
    <!-- Logo -->
    <!-- ============================================================== -->
    <div class="navbar-header text-justify" style="max-height: 55px">
      <a *ngIf="userRole !== 5" class="navbar-brand" href="index.html">
        <b>
          <img *ngIf="!showMiniSidebar" src="assets/images/trobbit-logo.png" alt="homepage" class="dark-logo"
            style="width: 100%; height: 55px" />
          <img *ngIf="showMiniSidebar" src="assets/images/trobbit-toggle-dismiss.png" style="max-width: 80%;" alt="homepage" class="dark-logo" />
        </b>
      </a>

      <a *ngIf="userRole === 5" class="navbar-brand" [routerLink]="['/admin/conversations']">
        <b>
          <img src="assets/images/trobbit-toggle-dismiss.png" style="max-width: 80%;" alt="homepage" class="dark-logo" />
        </b>
      </a>
    </div>
    <!-- ============================================================== -->
    <!-- End Logo -->
    <!-- ============================================================== -->
    <div class="navbar-collapse">
      <!-- ============================================================== -->
      <!-- toggle -->
      <!-- ============================================================== -->
      <ul class="navbar-nav">
        <li *ngIf="userRole !== 5" (click)="toggleSidebar.emit()" class="nav-item"> <a
            class="nav-link sidebartoggler text-muted waves-effect waves-dark" href="javascript:void(0)"><i class="ti-menu"></i></a>
        </li>

        <li *ngIf="userRole === 5" [routerLink]="['/admin/conversations']" class="nav-item">
          <button [ngClass]="userRoute === '/admin/conversations' ? 'nav-selected' : ''"
            class="nav-link waves-effect waves-dark btn btn-conversations">
            <i class="mdi mdi-message"></i>
            <span class="nav-u-name">{{('shared.sidebar.conversations') | translate}}</span>
          </button>
        </li>
      </ul>
      <!-- ============================================================== -->
      <!-- User profile, search and nav items -->
      <!-- ============================================================== -->
      <ul class="navbar-nav ml-auto">
        <!-- ============================================================== -->
        <!-- Notifications -->
        <!-- ============================================================== -->
        <li *ngIf="userRole === 5" class="nav-item dropdown ml-3 notifications" ngbDropdown placement="bottom-right">
          <!-- todo ⚠️⚠️⚠️ <a ngbDropdownToggle class="nav-link text-muted text-muted waves-effect waves-dark" href="javascript:void(0)">
            <i class="mdi mdi-bell-outline nav-icon"></i>
            <div class="notify"> <span class="heartbit"></span> <span class="point"></span> </div>
          </a> -->

          <div class="dropdown-menu dropdown-menu-right notificationbox" ngbDropdownMenu>
            <ul>
              <li class="p-2  border-bottom">
                <div class="text-center">{{'shared.headerNavigation.notifications' | translate}}</div>
              </li>
              <li>
                <div class="message-center notificationbox-height" [perfectScrollbar]="config">
                  <a href="javascript:void(0);" *ngIf="notifications.length === 0">
                    <span class="p-3 text-muted">No hay notificaciones por el momento.</span>
                  </a>
                  <a href="javascript:void(0);" *ngFor="let notification of notifications; index as i" class="border-bottom">
                    <div class="notificationbox-icon"><i class="round {{notification.round}} {{notification.icon}}"></i>
                    </div>
                    <div class="notificationbox-content">
                      <h5>{{notification.title}}</h5>
                      <span class="mail-desc">{{notification.subject}}</span>
                      <span class="time">{{notification.time}}</span>
                    </div>
                    <div class="notificationbox-close">
                      <button type="button" class="close p-1" aria-label="Close" (click)="removeNotification(i)">
                        <span aria-hidden="true">&times;</span></button>
                    </div>
                  </a>
                </div>
              </li>
              <!-- <li>
                <a class="nav-link text-center" href="javascript:void(0);"> <strong>{{'shared.headerNavigation.checkAllNotifications' | translate}}</strong> <i
                    class="fa fa-angle-right"></i> </a>
              </li> -->
            </ul>
          </div>
        </li>
        <!-- ============================================================== -->
        <!-- End Notifications -->
        <!-- ============================================================== -->
        <li class="nav-item ml-2" style="display: flex; align-items: center" *ngIf="auth.user.role.name === 'superadmin'">
          <small for="company-select" style="vertical-align: center;">{{'shared.headerNavigation.companyChoose' |
            translate}} </small>
        </li>
        <li class="nav-item ml-2" style="display: flex; align-items: center" *ngIf="auth.user.role.name === 'superadmin'">
          <select class="custom-select custom-select-sm" id="company-select" name="company-select"
            (change)="changeCompany($event,companyList)" [(ngModel)]="auth.user.company.id">
            <option *ngFor="let company of companyList" value="{{company.id}}">{{company.name}}</option>
          </select>
        </li>
        <li class="nav-item dropdown u-pro ml-2" ngbDropdown placement="bottom-right">
          <a ngbDropdownToggle class="nav-link dropdown-toggle waves-effect waves-dark profile-pic pl-md-2 pl-lg-2"
            href="javascript: void(0);" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="border-left: 0;">
            <div class="u-img col-md-12 col-lg-3 ml-0 p-0 pr-lg-0">
              <img [src]="auth.user.photoUrl ? auth.user.photoUrl : 'assets/images/profile-placeholder.png'" class="img-circle"
                style="border-radius: 50%; height: 35px; width: 35px;" width="20" height="20" alt="user">
              <i *ngIf="userRole === 5" class="fa fa-circle profile-status-ico" [ngClass]="userSessionStatus?.name" aria-hidden="true"></i>
            </div>
            <span class="nav-u-name hidden-md-down">{{auth.user.firstName}} &nbsp;<i class="fa fa-angle-down"></i></span>
          </a>
          <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right u-pro-menu">
            <ul class="dropdown-user">

              <li class="dropdown-user-header">
                <div class="dw-user-box">

                  <div class="u-img">
                    <img [src]="auth.user.photoUrl ? auth.user.photoUrl : 'assets/images/profile-placeholder.png'" class="img-circle"
                      style="border-radius: 50%; height: 60px; width: 60px;" width="30" height="30" alt="user">
                  </div>

                  <div class="u-text">
                    <h4>{{auth.user.firstName}}</h4>
                    <p class="text-muted">{{auth.user.email}}</p>
                    <p class="text-muted">{{auth.user.company.name}}</p>
                    <p class="text-muted" [innerHTML]="formatRole(auth.user.role.name)"></p>
                  </div>

                </div>
              </li>

              <li ngbDropdownToggle [routerLink]="'/admin/profile'">
                <a style="cursor: pointer"><i class="ti-user"></i>
                  {{'shared.headerNavigation.myProfile' | translate}}
                </a>
              </li>
              <li *ngIf="userRole === 5"><app-user-availability (sessionStatusOutput)="changeSessionStatus($event)"></app-user-availability>
              </li>
              <li><app-language-selector></app-language-selector></li>
              <div class="d-inline-block"></div>
              <li class="u-logout" (click)="logout()"><a style="cursor: pointer"><i class="fa fa-sign-out"></i>
                  {{'shared.headerNavigation.logout' | translate}} </a></li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</header>
